import {DashboardPlugin} from "../../../core/plugin/PluginType";
import CurrentWorkTimeWidget from "./CurrentWorkTimeWidget";

const CurrentWorkTimeDashboardPlugin: DashboardPlugin = {
    id: 'my-clock-in-out-widget',
    name: 'Meine Arbeitszeit',
    icon: 'stopwatch',
    version: '1.0.0',
    description: 'Displays summary of employee statistics',
    author: 'Your Company',
    type: 'dashboard',
    component: CurrentWorkTimeWidget,
    defaultSize: 'medium',
    isPinned: true,
    defaultPreferences: {},
    requiredPermissions: ['dashboard.plugins.current-work-time.view'],
};

export default CurrentWorkTimeDashboardPlugin;